import React, { useState } from "react"
import { Marker } from "react-map-gl"
import type { ImageMarkerProps } from "../../../types"

const ImageMarker: React.FC<ImageMarkerProps> = ({ latitude, longitude, image, isSelected, onClick, onMouseEnter, onMouseLeave }) => {
  const [hovering, setHovering] = useState(false)

  return (
    <Marker longitude={longitude} latitude={latitude} anchor="center" style={{ zIndex: isSelected ? 999 : 1 }}>
      {isSelected && <div className="marker-pulse" />}
      <div
        className={`marker images ${isSelected ? "selected" : ""} ${hovering ? "hover" : ""}`}
        onClick={onClick}
        onMouseEnter={() => {
          setHovering(true)
          onMouseEnter?.()
        }}
        onMouseLeave={() => {
          setHovering(false)
          onMouseLeave?.()
        }}
      >
        {image && <img src={image} alt="" loading="lazy" style={{ maxWidth: "100%" }} />}
      </div>
    </Marker>
  )
}

export default ImageMarker
